import React from 'react';
import { createContext } from 'use-context-selector';
import useLocalStorageKey from '../../hooks/useLocalStorageKey';
import SeptimLoadingSpinner from '../../components/Manager/SeptimLoadingSpinner/SeptimLoadingSpinner';
import { UserState, UserStateAction } from '../../types/context';
import { HydratedUserStateProvider } from './components/HydratedUserStateProvider';
import { useFormTokensHydration } from './hooks/useFormTokensHydration';

interface Props {
  children: React.ReactNode;
  mockState?: Partial<UserState>;
}

type Dispatch = (action: UserStateAction) => void;

const UserStateContext = createContext<
  { state: UserState; dispatch: Dispatch } | undefined
>(undefined);

// Gate: token meta lives in IndexedDB (JS-1208) and must be hydrated before any
// child renders — form mount effects replace tokens they cannot find in state
const UserStateProvider = (props: Props) => {
  const localStorageKey = useLocalStorageKey();
  const hydration = useFormTokensHydration(localStorageKey);

  if (!hydration.done) {
    return <SeptimLoadingSpinner height="100vh" />;
  }

  return (
    <HydratedUserStateProvider
      {...props}
      initialFormTokens={hydration.formTokens}
    />
  );
};

export { UserStateProvider, UserStateContext };
